import Vue from 'vue';

import { BootstrapVue } from 'bootstrap-vue';
import axios from 'axios';

// own files
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n'
import imageMixin from "@/mixins/imageMixin";
import localeMixin from "@/mixins/localeMixin";
import { mapGetters } from "vuex";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.config.productionTip = false;

Vue.mixin(imageMixin);
Vue.mixin(localeMixin);
Vue.use(BootstrapVue);

new Vue({
  router,
  store,
  i18n,
  created() {
    console.log('Loaded configurator version 1.2.1');
    if (
        document.getElementById('app').dataset.mode === 'magento' ||
        document.getElementById('app').dataset.mode === 'ccv'
    ) {
      this.$store.commit('preference/setMode', document.getElementById('app').dataset.mode);
      this.$store.commit('preference/setGenerator', document.getElementById('app').dataset.generator);
      this.$store.commit('preference/setUrlSlug', document.getElementById('app').dataset.url_slug);
      this.$store.commit('preference/setLocale', document.getElementById('app').dataset.locale);
      this.$store.commit('preference/setMagentoLoggedIn', document.getElementById('app').dataset.logged_in);
      document.title = document.getElementById('app').dataset.title;
    }
  },
  computed: {
    ...mapGetters({
      locale: 'preference/getLocale',
    }),
  },
  mounted() {
    this.$i18n.locale = this.locale;
  },
  render: (h) => h(App)
}).$mount('#app');

var $ = require("jquery");

export function scrollTop() {
  let motors = $('.motors');
  for (let i = 0; i < motors.length; i++) {
   $('.motors').animate({scrollTop: motors[i]}, 100);
  }
}
